import React from 'react';

const educationContent = [
  {
    year: '2023',
    degree: 'Introduction to Computer Science',
    institute: 'CS50x HarvardX',
    details: `Computer Science, Data Structures, Algorithms, Web Development, Encapsulation, Resource Management, Security, Software Engineering`,
  },
  {
    year: '2020',
    degree: 'BACHELOR DEGREE ',
    institute: 'AAB UNIVERSITY',
    details: `Bachelor of Science in Managment and Informatics`,
  },
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Education;
